import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { LocalizedText } from 'bernie-l10n';

import { PrebundledPackagesSearchEntry } from '@shared-ui/retail-multi-item-prebundled-packages-search-entry';
import { VoiceOfTheCustomer } from '@shared-ui/customer-voice-of-the-customer';

import { UitkSpacing } from 'uitk-react-spacing';

import { IncentivesCollectionCarouselWrapper } from 'components/search/shared-ui/shared-ui-incentives-collection-carousel';
import { MesoFooter } from '../../meso/meso-footer';
import { PropertySearchListings } from '../property-search-listings/property-search-listings';

export const Results = inject('searchResults')(
  observer(({ searchResults, handleShowMore, setResultRef, legalDisclaimer, errorMessage, similarDestinationProps = null }) => {
    const shoppingContextMultiItemId = searchResults.shoppingContextMultiItemId;

    return (
      <>
        {!searchResults.isError && shoppingContextMultiItemId && (
          <>
            <PrebundledPackagesSearchEntry inputs={{ sessionId: shoppingContextMultiItemId }} />
          </>
        )}
        <h2 className="is-visually-hidden">
          <LocalizedText message="hotels.search.results.heading" />
        </h2>
        <PropertySearchListings setResultRef={setResultRef} handleShowMore={handleShowMore} />
        {errorMessage}
        {similarDestinationProps && <IncentivesCollectionCarouselWrapper {...similarDestinationProps} />}
        <MesoFooter />
        <ErrorBoundary label="voice-of-the-customer">
          <UitkSpacing margin={{ medium: { blockstart: 'six' } }}>
            <div data-stid="shared-ui-voice-of-the-customer">
              <VoiceOfTheCustomer inputs={{}} />
            </div>
          </UitkSpacing>
        </ErrorBoundary>
        {legalDisclaimer?.content && (
          <UitkSpacing padding={{ block: 'six' }}>
            <p
              dangerouslySetInnerHTML={{
                __html: legalDisclaimer?.content
                  .filter(content => content.markupType === 'HTML')
                  .map(content => content.text)
                  .join('<br/><br/>'),
              }}
            />
          </UitkSpacing>
        )}
      </>
    );
  })
);
